import 'select2'

// Configuração padrão para Select2: "ocupe toda a largura".
// Facilita uso de Grid.
$.fn.select2.defaults.set('width', '100%')
